import { ModalProps } from 'antd';
import styled, { DefaultTheme } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const StyledDrawerModalTitle = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  color: ${({ theme }) => theme.Color.Neutrals.Dark};
`;

export const getStyles = (
  theme: DefaultTheme,
  areBordersHidden: boolean,
  fixedBodyHeight?: string | number,
  minBodyHeight?: string | number
): {
  modal: ModalProps['styles'];
} => ({
  modal: {
    header: {
      borderBottomColor: 'transparent',
      paddingBottom: 0,
      backgroundColor: 'transparent',
    },
    footer: { borderTopColor: theme.Color.Neutrals.Border },
    body: {
      padding: !areBordersHidden ? utils.rem(theme.Border.Size.XLarge) : 0,
      height:
        typeof fixedBodyHeight === 'string'
          ? fixedBodyHeight
          : fixedBodyHeight !== undefined
          ? utils.rem(fixedBodyHeight)
          : undefined,
      minHeight:
        typeof minBodyHeight === 'string'
          ? minBodyHeight
          : minBodyHeight !== undefined
          ? utils.rem(minBodyHeight)
          : undefined,
      overflowY: fixedBodyHeight ? 'auto' : 'visible',
    },
    content: {
      borderRadius: utils.rem(theme.Border.Radius.XLarge),
    },
  },
});
